module.exports = __webpack_public_path__ + "img/service-one.7b240e3a.png";